import { Injector } from '@angular/core';

/**
 * Holds a reference to the root injector so plain functions (e.g. Quill toolbar handlers)
 * can resolve Angular services. Set in AppComponent constructor.
 */
export let rootInjector: Injector | null = null;

export function setRootInjector(injector: Injector): void {
    rootInjector = injector;
}
